import { Button, Input } from 'antd'
import styled from 'styled-components'
import { IconFont } from '../iconfont'

interface InputProps extends React.ComponentProps<typeof Input> {}

interface ButtonProps extends React.ComponentProps<typeof Button> {}

interface SearchInputProps {
  containerProps?: typeof SearchInputContainer
  inputProps?: InputProps
  buttonProps?: ButtonProps
  style?: React.CSSProperties
}

export const SearchInputTwo = (props: SearchInputProps) => {
  const { inputProps, buttonProps, containerProps, style } = props

  return (
    <SearchInputContainer {...containerProps} style={style}>
      <Input.Group compact style={{ display: 'flex', height: '32px' }}>
        <FlexInput
          {...inputProps}
          prefix={<IconFont type="icon-sousuo1" style={{ color: '#666', fontSize: 16 }} />}
        />
      </Input.Group>
    </SearchInputContainer>
  )
}

const SearchInputContainer = styled.div``

const FlexInput = styled(Input)`
  flex-grow: 1;
`
